// "What's New" changelog.
// HOW TO USE: When you ship a new feature, add a new entry to the TOP of the
// CHANGELOG array and bump CHANGELOG_VERSION to match its `version`.
// On their next visit, all users will see the What's New popup once.
// Icons must be one of the keys in ICONS (see WhatsNewModal.jsx).

export const CHANGELOG_VERSION = '2026.06.15';

export const CHANGELOG = [
  {
    version: '2026.06.15',
    date: 'June 15, 2026',
    title: 'Podcasts & Audiobooks',
    highlights: [
      { icon: 'Mic', text: 'Podcasts have arrived — dedicated Podcasts section with shows, episodes and categories. Premium creators can publish their own.' },
      { icon: 'BookOpen', text: 'Audiobooks too — browse books by category, with author & narrator details and chapters in order.' },
      { icon: 'Zap', text: 'Continue Listening — podcasts and audiobooks now remember where you stopped and resume right there.' },
      { icon: 'Bell', text: 'Follow your favorite shows & books to get notified the moment a new episode or chapter drops — plus playback speed control (1x–2x) and a full playlist manager.' },
    ],
  },
  {
    version: '2026.05.30',
    date: 'May 30, 2026',
    title: 'Storefront & Speed',
    highlights: [
      { icon: 'ShoppingBag', text: 'Album Sales — premium creators can now sell full albums with instant download rights.' },
      { icon: 'Zap', text: 'Faster everywhere — artwork and audio now stream from a global edge network for quicker loads.' },
      { icon: 'Sparkles', text: 'A fresh welcome experience greets you when you first land on the site.' },
    ],
  },
  {
    version: '2026.05.01',
    date: 'May 1, 2026',
    title: 'Creator Tools',
    highlights: [
      { icon: 'DollarSign', text: 'Tip your favorite artists directly from any track page.' },
      { icon: 'Crown', text: 'New Premium Yearly plan — $97/yr including offline downloads.' },
    ],
  },
];
